import { render, staticRenderFns } from "./SubscriptionCancelReason.vue?vue&type=template&id=135cc652&scoped=true&"
import script from "./SubscriptionCancelReason.vue?vue&type=script&lang=js&"
export * from "./SubscriptionCancelReason.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionCancelReason.vue?vue&type=style&index=0&id=135cc652&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135cc652",
  null
  
)

export default component.exports